import { render, staticRenderFns } from "./ManageTeams.vue?vue&type=template&id=9fd28f92"
import script from "./ManageTeams.vue?vue&type=script&lang=ts"
export * from "./ManageTeams.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports